import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=1cdb3f82&scoped=true&"
import script from "./AddRole.vue?vue&type=script&lang=js&"
export * from "./AddRole.vue?vue&type=script&lang=js&"
import style0 from "./AddRole.vue?vue&type=style&index=0&id=1cdb3f82&scoped=true&lang=css&"
import style1 from "./AddRole.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdb3f82",
  null
  
)

export default component.exports